<template>
  
    <LayoutError>

        <div id="404" class="mt-4"> 
            
            <p class="text-center">
                
                {{$t('page.error')}}

            </p>

        </div>

    </LayoutError>

</template>

<script>

  import LayoutError from '@/components/layouts/LayoutError.vue';

  export default {
    name: 'NotFound',
    components: {
      LayoutError
    },
    i18n: { 
      messages: {
        es: {
          page: { 
            error: 'Página no encontrada'
          }
        },
        eu: {
          page: { 
            error: 'Orria ezin da topatu'
          }
        },
      }
    }
  }
</script>